import { Color } from '@ark-ui/react'
import { parseColor } from '@ark-ui/react/color-picker'

import { cn } from '@/utils'

const swatchList = [
	'#000000',
	'#5F5F5F',
	'#9A9A9A',
	'#CBCBCB',
	'#E1E1E1',
	'#FFFFFF',
	'#FF0C0B',
	'#FF8A1D',
	'#2CA676',
	'#006EF9',
	'#7F25FF',
	'#FF21A0',
	'#FF5F5F',
	'#FFB56E',
	'#4FD2A0',
	'#4C9BFF',
	'#B078FF',
	'#FF73C2',
	'#FFB1B1',
	'#FFDFC0',
	'#92E3C3',
	'#9DC8FF',
	'#DECAFF',
	'#FEC5E6',
	'#FFD8D9',
	'#FFF2E9',
	'#B1EBD5',
	'#C5DFFE',
	'#F8F2FF',
	'#FFEEF8',
	'#FF9FA0',
	'#9A6464',
	'#583C3B',
	'#931C1D',
	'#1D4743',
	'#E2FEA2',
	'#FEDAB8',
	'#416456',
	'#57C2FE',
	'#BF91FE',
	'#41CB8B',
	'#D66566',
	'#903FB8',
	'#FF8E56',
	'#B8EDFE',
	'#9D837A',
	'#6D7D86',
	'#EDBDBD',
	'#E76EB3',
	'#5E9BE8',
	'#FFBD9C',
	'#4F6474',
	'#8798A5',
	'#C1D0DB',
]

export const ColorPalette = ({
	setValue,
}: {
	setValue: (value: Color) => void
}) => (
	<div className="grid grid-cols-[repeat(auto-fill,_minmax(2rem,_1fr))] gap-[5px]">
		{swatchList.map((color) => (
			<button
				key={color}
				onClick={() => setValue(parseColor(color))}
				className={cn(
					'aspect-square rounded-6',
					color === '#FFFFFF' && 'border border-border-grey',
				)}
				style={{ backgroundColor: color }}
			/>
		))}
	</div>
)
